import React, { useState } from "react";
import { Button, Form, Modal } from '@themesberg/react-bootstrap';
import { useCookies } from "react-cookie";
import { addMegaResults } from "../../../../../controller/api/gameResult";

export default (props) => {

  const [cookies] = useCookies(['lottmekong'])

  const [numbers, setNumbers] = useState(['', '', '', '', '', ''])
  const [jackpotPrize1, setJackpotPrize1] = useState('')
  const [jackpot1Winner, setJackpot1Winner] = useState('0')

  const _onHide = () => {
    setNumbers(['', '', '', '', '', ''])
    setJackpotPrize1('')
    setJackpot1Winner('0')
    props.onHide()
  }

  const handleNumberChange = (index, value) => {
    const newNumbers = [...numbers]
    newNumbers[index] = value
    setNumbers(newNumbers)
  }

  const onSubmit = async () => {
    const validNumbers = numbers.filter(n => n && n.length > 0)
    if (validNumbers.length !== 6) {
      alert('Vui lòng nhập đầy đủ 6 số')
      return
    }

    if (!/^\d+$/.test(jackpotPrize1) || !/^\d+$/.test(jackpot1Winner)) {
      alert('Vui lòng nhập giá trị Jackpot và số người trúng')
      return
    }

    const resp = await addMegaResults(cookies.lottmekong, {
      periodId: props.period.id,
      numbers,
      jackpotPrize1,
      jackpot1Winner: Number(jackpot1Winner)
    })
    if (resp) {
      window.location.reload()
    } else {
      alert('Có lỗi xảy ra')
      return false
    }
  }

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={_onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Nhập kết quả Mega 6/45 - Kỳ #{props.period && props.period.name}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {[0, 1, 2, 3, 4, 5].map((idx) => (
            <Form.Group key={idx} className="mb-3">
              <Form.Label>Số {idx + 1}</Form.Label>
              <Form.Control
                type="text"
                placeholder={`Nhập số ${idx + 1}`}
                value={numbers[idx]}
                onChange={(e) => handleNumberChange(idx, e.target.value)}
              />
            </Form.Group>
          ))}
          <Form.Group className="mb-3">
            <Form.Label>Giá trị Jackpot (đồng)</Form.Label>
            <Form.Control
              type="text"
              inputMode="numeric"
              placeholder="Nhập giá trị Jackpot chính thức"
              value={jackpotPrize1}
              onChange={(e) => setJackpotPrize1(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Số người trúng Jackpot</Form.Label>
            <Form.Control
              type="number"
              min="0"
              value={jackpot1Winner}
              onChange={(e) => setJackpot1Winner(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={_onHide}>Close</Button>
        <Button variant="primary" onClick={onSubmit}>Thêm</Button>
      </Modal.Footer>
    </Modal>
  );
}
